<template>
  <u-dropdown
    :items="[
      [
        {
          label: 'Copy Link',
          icon: 'i-ph-link',
          click: copyLink,
        },
        {
          label: 'Share on Facebook',
          icon: 'i-ph-facebook-logo',
          click: () => shareOnSocial('facebook'),
        },
        {
          label: 'Share on Twitter',
          icon: 'i-ph-twitter-logo',
          click: () => shareOnSocial('twitter'),
        },
      ],
    ]"
    :popper="{ placement: 'bottom-end' }"
  >
    <u-icon class="cursor-pointer pr-24" name="i-ph-share-fat" />
  </u-dropdown>
</template>

<script lang="ts" setup>
const props = defineProps<{
  vanityUrl?: string
  title: string
  description?: string
  userId?: string | null
}>()

const { url } = useShareUrl(props.vanityUrl)
const { copy, isSupported } = useClipboard()
const toast = useToast()
const posthog = useNuxtApp().$clientPosthog

function copyLink() {
  if (!isSupported.value) return

  copy(url.value)
  toast.add({
    color: 'green',
    title: 'Copied link to clipboard!',
  })
}

function shareOnSocial(platform: 'facebook' | 'twitter') {
  if (platform === 'facebook') {
    if (typeof window.FB !== 'undefined') {
      window.FB.ui({
        method: 'share',
        href: url.value,
      })
      posthog?.capture('facebook_share_clicked', {
        platform: 'facebook',
        method: 'sdk',
        url: url.value,
        title: props.title,
        userId: props.userId,
      })
    } else {
      window.open(
        `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url.value)}`,
        '_blank',
      )
      posthog?.capture('facebook_share_clicked', {
        platform: 'facebook',
        method: 'window',
        url: url.value,
        title: props.title,
        userId: props.userId,
      })
    }
  } else if (platform === 'twitter') {
    const text =
      props.description || `Check out ${props.title} on The Show Portal!`
    window.open(
      `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url.value)}`,
      '_blank',
    )
    posthog?.capture('twitter_share_clicked', {
      platform: 'twitter',
      method: 'window',
      url: url.value,
      title: props.title,
      userId: props.userId,
    })
  }
}
</script>
